import { handleActions, handleAction } from "redux-actions";
import {
  AUTH,
  SET_PROFILE,
  SET_CURRENT_ROUTE,
  LOGOUT,
  SHOW_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_SIDE_MENU_STATE,
  OPEN_ALERT_FORM,
  CLOSE_ALERT_FORM,
  EDIT_SELECTED_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  SET_ALERT_LIST,
  ADD_NEW_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  THEME,
} from "./../../constants";
import { createCrudReducers } from "../../utils/crudGenerator";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) => action.payload,
  {}
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  false
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

const userReducers = createCrudReducers('USER');

export const users = userReducers.list;
export const usersForm = userReducers.form;

const roleReducers = createCrudReducers('ROLE');

export const roles = roleReducers.list;
export const rolesForm = roleReducers.form;

const zoneReducers = createCrudReducers('ZONE');

export const zones = zoneReducers.list;
export const zonesForm = zoneReducers.form;
const containerReducers = createCrudReducers('CONTAINER');

export const containers = containerReducers.list;
export const containersForm = containerReducers.form;
const containermeasurementReducers = createCrudReducers('CONTAINERMEASUREMENT');

export const containermeasurements = containermeasurementReducers.list;
export const containermeasurementsForm = containermeasurementReducers.form;
const hoteldataReducers = createCrudReducers('HOTELDATA');

export const hoteldatas = hoteldataReducers.list;
export const hoteldatasForm = hoteldataReducers.form;
const hotelchainReducers = createCrudReducers('HOTELCHAIN');

export const hotelchains = hotelchainReducers.list;
export const hotelchainsForm = hotelchainReducers.form;
const establishmentReducers = createCrudReducers('ESTABLISHMENT');

export const establishments = establishmentReducers.list;
export const establishmentsForm = establishmentReducers.form;
const wastetypeReducers = createCrudReducers('WASTETYPE');

export const wastetypes = wastetypeReducers.list;
export const wastetypesForm = wastetypeReducers.form;

const zonecategoryReducers = createCrudReducers('ZONECATEGORY');
export const zonecategories = zonecategoryReducers.list;
export const zonecategoriesForm = zonecategoryReducers.form;

const supportReducers = createCrudReducers("SUPPORT");
export const supports = supportReducers.list;
export const supportsForm = supportReducers.form;
